export const actionTypes = {
  GET_SERVICE_BILLING_SUCCESS: 'GET_SERVICE_BILLING_SUCCESS',
  GET_SERVICE_BILLING_FAILURE: 'GET_SERVICE_BILLING_FAILURE',
  GET_SERVICE_BILLING_LOADER: 'GET_SERVICE_BILLING_LOADER',

  POST_SERVICE_BILLING_SUCCESS: 'POST_SERVICE_BILLING_SUCCESS',
  POST_SERVICE_BILLING_FAILURE: 'POST_SERVICE_BILLING_FAILURE',

  // Kept separate from POST_SERVICE_BILLING_* so opening the Audit History
  // accordion (postServiceBilling under the hood, same as every other
  // actionType) can never overwrite ServiceBillingData — the page's own
  // displayed invoice — the same way Project Maintenance's audit history
  // slot is kept apart from PMCaseData/ProjectInfo.
  GET_SERVICE_BILLING_AUDIT_HISTORY_SUCCESS: 'GET_SERVICE_BILLING_AUDIT_HISTORY_SUCCESS',
  GET_SERVICE_BILLING_AUDIT_HISTORY_FAILURE: 'GET_SERVICE_BILLING_AUDIT_HISTORY_FAILURE',
  GET_SERVICE_BILLING_AUDIT_HISTORY_LOADER: 'GET_SERVICE_BILLING_AUDIT_HISTORY_LOADER',

  // One loader flag per Pega actionType posted through postServiceBilling,
  // instead of a single flag shared by every call.
  VIEW_INVOICE_LOADER: 'VIEW_INVOICE_LOADER',
  SKIP_EMAIL_PROCESS_LOADER: 'SKIP_EMAIL_PROCESS_LOADER',
  PROCEED_TO_SEND_EMAIL_LOADER: 'PROCEED_TO_SEND_EMAIL_LOADER',
  SAVE_INVOICE_DETAILS_LOADER: 'SAVE_INVOICE_DETAILS_LOADER',
  INDIVIDUAL_SEND_EMAIL_LOADER: 'INDIVIDUAL_SEND_EMAIL_LOADER',
  SEND_BACK_TO_INVOICE_GENERATE_LOADER: 'SEND_BACK_TO_INVOICE_GENERATE_LOADER',
  UPDATED_RECEIPT_DATA_LOADER: 'UPDATED_RECEIPT_DATA_LOADER',
  WRITTEN_OFF_LOADER: 'WRITTEN_OFF_LOADER',
  SEND_BACK_TO_PM_LOADER: 'SEND_BACK_TO_PM_LOADER',
  SET_PENDING_UPDATE_INVOICE: 'SET_PENDING_UPDATE_INVOICE',
};
